import {useState, useEffect} from 'react';

import {isEmpty} from 'lodash';
import {useParams} from 'react-router';

import {getPublicAccreditationScopes} from 'api/accreditation-bodies';
import {alertByError} from 'utils/alerts';

const useGetScopes = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    main: [],
    sub4: [],
    sub5: [],
  });
  const [meta, setMeta] = useState({});

  const {abId} = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicAccreditationScopes(abId);

      if (!isEmpty(data)) {
        data.forEach((item) => {
          setData((prev) => ({
            main:
              item.scope_type === 'Main'
                ? [...(prev.main && prev.main), item]
                : prev.main,
            sub4:
              item.level === 'Level 4'
                ? [...(prev.sub4 && prev.sub4), item]
                : prev.sub4,
            sub5:
              item.level === 'Level 5'
                ? [...(prev.sub5 && prev.sub5), item]
                : prev.sub5,
          }));
        });
      }
      setMeta(meta);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {isLoading, meta, data};
};

export default useGetScopes;
